import {
    IonButton,
    IonButtons,
    IonCard,
    IonCardContent,
    IonCardSubtitle,
    IonCardTitle,
    IonCol,
    IonContent,
    IonIcon,
    IonModal,
    IonPage,
    IonRow,
    IonTitle,
    IonToolbar,
    isPlatform,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import ErrorAlert from "../../../../../../components/Errors/ErrorAlert";
import Header from "../../../../../../components/Headers/Header";
import PageTitle from "../../../../../../components/PageTitle/PageTitle";
import { RouteComponentProps } from "react-router";
import { Organization, PointTable } from "../../../../../../models";
import { getOrganizationById } from "../../../../../../utilities/organization/Organization";
import PointTableExplanationModal from "../../../../../../components/PointTable/PointTableExplanationModal";
import AddPointTableCard from "../../../../../../components/PointTable/AddPointTableCard";
import PointTableEditForm from "../../../../../../components/PointTable/PointTableEditForm";
import PointTableEditTable from "../../../../../../components/PointTable/PointTableEditTable";
import { close } from "ionicons/icons";

interface OrganizationPageProps extends RouteComponentProps<{
    id: string;
}> {}

const OrganizationPointsTemplatesPage: React.FC<OrganizationPageProps> = ({match}) => {
    const [organization, setOrganization] = useState<Organization>();
    const [selectedPointTable, setSelectedPointTable] = useState<PointTable | undefined>();
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        async function getOrganization() {
            const queryResult = await getOrganizationById(match.params.id);
            if (queryResult.isSuccess) {
                setOrganization(queryResult.result);
            } else {
                setError("Sorry, a problem occurred. Please go back and try again.");
            }
        }

        getOrganization();
    }, [match, match.params.id]);

    const onSelectPointTemplate = (table: PointTable, isMobile: Boolean) => {
        setSelectedPointTable(table);
        if (isMobile) {
            setShowModal(true);
        }
    }

    return (
        <IonPage className="bg-light">
            <Header />
            <IonContent>
                <PageTitle title={organization ? organization.name : "Organization"} />
                <IonRow className="ion-justify-content-center">
                    {error && <ErrorAlert width="12" error={error} />}
                    <IonCol size="12">
                        <IonCard mode="md" className="ion-padding bg-white">
                            <IonCardTitle>Organization Point Templates</IonCardTitle>
                            <IonCardSubtitle><PointTableExplanationModal /></IonCardSubtitle>
                        </IonCard>
                    </IonCol>
                </IonRow>
                {isPlatform("mobile") ?
                    <>
                        <IonRow className="ion-justify-content-center">
                            <IonCol size="12">
                                {organization && (
                                    <AddPointTableCard organizationId={organization.id} handleNewPointTable={() => {console.log("Saw a new point table!")}} />
                                )}
                            </IonCol>
                        </IonRow>
                        <IonRow className="ion-justify-content-center">
                            <IonCol size="12">
                                {organization && (
                                    <PointTableEditTable onSelect={(c: PointTable) => onSelectPointTemplate(c, true)} organizationId={organization.id} />
                                )}
                            </IonCol>
                        </IonRow>
                        <IonModal backdropDismiss={false} isOpen={showModal} id="organizationPointTemplateModal">
                            <IonToolbar color="light">
                                <IonTitle className="ion-text-center">
                                    Edit Organization Point Template
                                </IonTitle>
                                <IonButtons slot="end">
                                    <IonButton
                                        fill="clear"
                                        onClick={() => setShowModal(false)}
                                    >
                                        <p id="closePointTableModalBtn" className="font-weight-normal text-medium text-capitalize">
                                            <IonIcon icon={close} />
                                        </p>
                                    </IonButton>
                                </IonButtons>
                            </IonToolbar>
                            <IonContent className="ion-padding">
                                {organization && selectedPointTable && (
                                    <PointTableEditForm organizationId={organization.id} pointTable={selectedPointTable} onSubmit={() => setShowModal(false)} />
                                )}
                            </IonContent>
                        </IonModal>
                    </>
                    :
                    <>
                        <IonRow className="ion-justify-content-center">
                            <IonCol sizeXs="12" sizeMd="6">
                                <IonCard mode="md" className="ion-padding bg-white">
                                   {organization && (
                                        <>
                                            <IonCardTitle>Table</IonCardTitle>
                                            <IonCardContent>
                                                <PointTableEditForm organizationId={organization.id} pointTable={selectedPointTable} onSubmit={() => console.log("Desktop - saw a new point table")} />
                                            </IonCardContent>
                                        </>
                                   )}
                                </IonCard>
                            </IonCol>
                            <IonCol sizeXs="12" sizeMd="6">
                                {organization && (
                                    <PointTableEditTable onSelect={(table: PointTable) => onSelectPointTemplate(table, false)} organizationId={organization.id} />
                                )}
                            </IonCol>
                        </IonRow>
                    </>
                }
            </IonContent>
        </IonPage>
    );
};

export default OrganizationPointsTemplatesPage;